(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comic-reader"] && !Shopify.designMode) return;
  try {
    
  /* The turn controls. The track reads without any of this — it snaps, swipes
     and takes arrow keys on its own — so everything here is added rather than
     depended on, and the position is always READ BACK from the scroll offset
     rather than tracked in a variable that a swipe would put out of date.

     A spread is exactly one track width in both layouts, which is why one
     rounding does for both and there is no breakpoint arithmetic anywhere
     except the count of dots. */
  class ComicBook {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-track]');
      this.pages = Number(root.dataset.count || 0);
      if (!this.track || !this.pages) return;

      const stage = root.closest('.reader__set') || root.parentElement;
      this.foot = stage.querySelector('[data-foot]');
      this.dots = stage.querySelector('[data-dots]');
      this.pos = stage.querySelector('[data-pos]');
      this.navs = [...root.querySelectorAll('[data-turn]')];

      this.sync = this.sync.bind(this);
      this.build();

      this.navs.forEach((b) => b.addEventListener('click', () => this.go(this.at() + Number(b.dataset.turn))));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.sync, 80);
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.go(this.at() + (e.key === 'ArrowRight' ? 1 : -1));
      });

      /* The number of dots is the one thing the layout changes. */
      this.mq = window.matchMedia('(max-width: 60rem)');
      this.mq.addEventListener('change', () => this.build());
    }

    get single() {
      return this.mq ? this.mq.matches : window.matchMedia('(max-width: 60rem)').matches;
    }

    get turns() {
      return this.single ? this.pages : Math.ceil(this.pages / 2);
    }

    build() {
      if (this.foot) this.foot.hidden = false;
      if (this.dots) {
        this.dots.replaceChildren(
          ...Array.from({ length: this.turns }, (_, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'reader__dot';
            b.setAttribute('aria-label', String(i + 1));
            b.addEventListener('click', () => this.go(i));
            return b;
          })
        );
      }
      this.sync();
    }

    at() {
      const w = this.track.clientWidth;
      return w ? Math.round(this.track.scrollLeft / w) : 0;
    }

    go(n) {
      const t = Math.min(Math.max(n, 0), this.turns - 1);
      this.track.scrollTo({ left: t * this.track.clientWidth, behavior: 'smooth' });
    }

    sync() {
      const n = Math.min(this.at(), this.turns - 1);
      if (this.dots) {
        [...this.dots.children].forEach((d, i) => d.setAttribute('aria-current', String(i === n)));
      }
      if (this.pos) {
        const first = this.single ? n + 1 : n * 2 + 1;
        const last = this.single ? first : Math.min(first + 1, this.pages);
        this.pos.textContent = `${first === last ? first : `${first}–${last}`} / ${this.pages}`;
      }
      this.navs.forEach((b) => {
        b.disabled = Number(b.dataset.turn) < 0 ? n === 0 : n >= this.turns - 1;
      });
    }
  }

  document.querySelectorAll('[data-book]').forEach((el) => new ComicBook(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["connect"]) return;
  try {
    
  if (!window.seremoriConnectCopyReady) {
    window.seremoriConnectCopyReady = true;
    const revealCopyButtons = (root = document) => {
      root.querySelectorAll('[data-connect-copy]').forEach((button) => { button.hidden = false; });
    };
    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-connect-copy]');
      if (!button) return;
      const root = button.closest('[data-connect]');
      const status = root?.querySelector('[data-connect-copy-status]');
      const email = root?.dataset.connectEmail;
      if (!status || !email) return;
      status.textContent = '';
      button.disabled = true;
      try {
        await navigator.clipboard.writeText(email);
        status.textContent = button.dataset.success;
      } catch {
        status.textContent = button.dataset.failure;
      } finally {
        button.disabled = false;
      }
    });
    document.addEventListener('shopify:section:load', (event) => revealCopyButtons(event.target));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealCopyButtons(), { once: true });
    } else {
      revealCopyButtons();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Two jobs, and deliberately no third: repaint the price and the size facts
     when the variant changes, and drop empty properties before submit so the
     order does not carry blank lines. Variant selection itself needs no script —
     the radios are `name="id"` and post straight to /cart/add. */
  class ProductForm {
    constructor(root) {
      if (root.querySelector('brass-customizer, portrait-customizer, magnet-customizer')) return;
      this.root = root;
      this.paint = this.paint.bind(this);

      root.querySelectorAll('[data-variant]').forEach((el) => {
        el.addEventListener('change', this.paint);
      });

      const form = root.querySelector('form');
      if (form) form.addEventListener('submit', () => this.dropEmpty(form));

      this.paint();
    }

    paint() {
      const chosen = this.root.querySelector('[data-variant]:checked');
      if (!chosen) return;

      const d = chosen.dataset;
      this.text('[data-price]', d.price);
      this.text('[data-price-label]', d.label);
      chosen.dispatchEvent(new CustomEvent('seremori:variant-change', { bubbles: true, detail: {
        money: d.price, price: Number(d.priceCents), comparePrice: Number(d.compareCents), compareMoney: d.compareMoney
      } }));

      this.fact('capacity', d.capacity, () => {
        this.text('[data-fact-capacity-value]', d.capacity);
        this.text('[data-fact-fits]', d.fits || '');
      });
      this.fact('dimensions', d.dimensions, () => {
        this.text('[data-fact-dimensions-value]', d.dimensions);
      });
    }

    /* A fact with no value hides its whole row. An empty `Capacity —` is worse
       than no capacity line: it reads as a specification nobody has filled in. */
    fact(key, value, fill) {
      const row = this.root.querySelector(`[data-fact-${key}]`);
      if (!row) return;
      if (value) {
        fill();
        row.hidden = false;
      } else {
        row.hidden = true;
      }
    }

    dropEmpty(form) {
      form.querySelectorAll('[name^="properties["]').forEach((el) => {
        const unset = el.type === 'radio' ? !el.checked : !el.value.trim();
        if (unset) el.disabled = true;
      });
    }

    text(selector, value) {
      const el = this.root.querySelector(selector);
      if (el) el.textContent = value;
    }
  }

  /* One frame, one rail. The shots are all in the DOM already — this only
     decides which one is not `hidden`, so there is no src swapping, no decode
     flash, and the browser has each file by the time it is asked for.

     It claims the gallery by adding a class rather than by being present,
     which is what lets the stylesheet keep the no-JavaScript fallback honest:
     until this line runs, the rail does not exist as far as the page is
     concerned and every shot is visible. */
  class Gallery {
    constructor(root) {
      if (root.hasAttribute('data-brass-gallery')) return;
      /* Thumbs are looked up on the SECTION, not on the gallery. The rail lives
         inside this root but the glaze chips are in the buy column beside it, and
         both are the same control: something that names a shot and shows it.
         Scoping to the root would have meant a second listener and a second copy
         of `show`. */
      const scope = root.closest('.product') || root;
      this.shots = Array.from(root.querySelectorAll('[data-shot]'));
      this.thumbs = Array.from(scope.querySelectorAll('[data-thumb]'));
      if (this.shots.length < 2 || !this.thumbs.length) return;

      root.classList.add('product__media--live');
      /* `change` as well as `click`: the chips are radios, and a keyboard user
         moving between them with the arrow keys gets change without click. */
      this.thumbs.forEach((t) => {
        const pick = () => this.show(Number(t.dataset.thumb));
        t.addEventListener('click', pick);
        t.addEventListener('change', pick);
      });
      this.show(0);
    }

    show(index) {
      this.shots.forEach((s) => {
        s.hidden = Number(s.dataset.shot) !== index;
      });
      this.thumbs.forEach((t) => {
        t.setAttribute('aria-current', Number(t.dataset.thumb) === index ? 'true' : 'false');
      });
    }
  }

  /* Shows the photograph the moment it is chosen. Without this the only feedback
     a frame gives is that its dashes closed up, and "did that attach?" is a bad
     question to leave somebody holding on a form about their dead animal.

     Object URLs are revoked on replace. Three frames is not a leak worth losing
     sleep over, but the same class runs on every product page in a session and
     the fix is one line. */
  class Uploads {
    constructor(root) {
      this.inputs = [...root.querySelectorAll('[data-upload]')];
      this.later = root.querySelector('[data-upload-later]');
      this.uploadNow = root.querySelector('[data-upload-now]');
      this.sync = () => {
        const sendLater = Boolean(this.later?.checked);
        if (this.uploadNow) this.uploadNow.hidden = sendLater;
        this.inputs.forEach(input => {
          input.disabled = sendLater;
          input.required = !sendLater && input.hasAttribute('data-upload-required');
        });
      };
      this.later?.addEventListener('change', this.sync);
      window.addEventListener('pageshow', this.sync);
      root.closest('form')?.addEventListener('reset', () => queueMicrotask(this.sync));
      this.sync();
      this.inputs.forEach((input) => {
        const label = input.closest('.upload');
        const img = label.querySelector('.upload__preview');
        input.addEventListener('change', () => {
          const file = input.files && input.files[0];
          if (img.src) URL.revokeObjectURL(img.src);
          if (!file) {
            img.hidden = true;
            img.removeAttribute('src');
            label.classList.remove('upload--filled');
            return;
          }
          img.src = URL.createObjectURL(file);
          img.hidden = false;
          label.classList.add('upload--filled');
        });
      });
    }
  }

  /* The tag field follows the chips. Without this the record says only which
     product was asked about, and the whole point of naming the glazes was to
     find out which one — an answer that arrives untagged is a name in a list.

     Two axes plus a snapshot, the same shape urn-configurator writes, so the
     admin's customer list filters on `pick-shell-pink` and the last field still
     reads on its own when somebody is replying by hand. */
  class CaptureTags {
    constructor(root) {
      this.field = root.querySelector('[data-capture-tags]');
      this.handle = root.dataset.captureHandle || '';
      if (!this.field) return;
      this.chips = Array.from(document.querySelectorAll('.product__glazes input'));
      if (!this.chips.length) return;
      this.chips.forEach((c) => {
        c.addEventListener('change', () => this.write());
        c.addEventListener('click', () => this.write());
      });
      this.write();
    }

    write() {
      const picked = this.chips.find((c) => c.checked);
      const value = picked ? picked.value : '';
      const axes = [`want-${this.handle}`, value && `pick-${value}`].filter(Boolean);
      this.field.value = axes.concat([this.handle, value].join('|')).join(',');
    }
  }

  document.querySelectorAll('[data-capture]').forEach((el) => new CaptureTags(el));
  document.querySelectorAll('[data-uploads]').forEach((el) => new Uploads(el));
  document.querySelectorAll('[data-gallery]').forEach((el) => new Gallery(el));
  document.querySelectorAll('[data-product-form]').forEach((el) => new ProductForm(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-memorial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const page = event.target.closest('[data-memorial-page]');
    if (!page) return;
    const comic = page.closest('[data-memorial-comic]');
    if (comic) comic.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urn-configurator"] && !Shopify.designMode) return;
  try {
    
  /* Everything the form changes is repainted from one place, so there is no state
     to keep in sync. Empty text falls back to the placeholder rather than to
     nothing: a blank urn reads as broken rather than as blank. */
  class UrnConfigurator {
    constructor(root) {
      this.root = root;
      this.name = root.querySelector('[data-engrave-name]');
      this.years = root.querySelector('[data-engrave-years]');
      this.urn = root.querySelector('[data-urn]');
      this.paint = this.paint.bind(this);

      this.prefill();

      [this.name, this.years].forEach((el) => el && el.addEventListener('input', this.paint));
      root.querySelectorAll('[data-size], [data-mark], [data-glaze], [data-pattern], [data-verdict]').forEach(
        (el) => el.addEventListener('change', this.paint)
      );

      this.paint();
      this.initSteps();
    }

    /* ONE FIELD PER SCREEN BELOW 62rem. The state is kept at every width and the
       CSS decides whether to draw it, so crossing the breakpoint needs no
       listener — above it `data-stepped` is inert. Nothing here touches the
       inputs, the tags or the submit; it only decides which fieldset is shown. */
    initSteps() {
      this.steps = Array.from(this.root.querySelectorAll('[data-step]'));
      this.stepper = this.root.querySelector('[data-stepper]');
      if (this.steps.length < 2 || !this.stepper) return;

      this.stepMq = window.matchMedia('(max-width: 61.99rem)');
      const stepOf = this.stepper.dataset.stepOf || '';

      this.stepper.textContent = '';
      this.steps.forEach((field, i) => {
        field.tabIndex = -1;
        const li = document.createElement('li');
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'stepper__dot';
        dot.setAttribute(
          'aria-label',
          `${stepOf.replace('[n]', i + 1).replace('[t]', this.steps.length)}: ${field.dataset.stepLabel || ''}`
        );
        const label = document.createElement('span');
        label.className = 'stepper__label';
        label.textContent = field.dataset.stepLabel || '';
        dot.appendChild(label);
        /* Dots are a way back, not a way forward: skipping ahead past the
           field being asked about is what Next is for, one at a time. */
        dot.addEventListener('click', () => {
          if (i < this.step) this.go(i);
        });
        li.appendChild(dot);
        this.stepper.appendChild(li);
      });

      const back = this.root.querySelector('[data-step-back]');
      const next = this.root.querySelector('[data-step-next]');
      if (back) back.addEventListener('click', () => this.go(this.step - 1));
      if (next) next.addEventListener('click', () => this.go(this.step + 1));

      /* Enter in a text field is the form's implicit submit, and the submit sits
         on the last step behind a required email — so Enter on the name step
         would ask the browser to focus a hidden input, which it refuses to do
         and reports nothing. While stepped, Enter means Next. */
      this.root.querySelectorAll('[data-step] input[type="text"]').forEach((el) =>
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && this.stepMq.matches) {
            e.preventDefault();
            this.go(this.step + 1);
          }
        })
      );

      this.root.dataset.stepped = '';
      this.go(0, false);
    }

    go(i, scroll = true) {
      i = Math.max(0, Math.min(this.steps.length - 1, i));
      this.step = i;

      this.steps.forEach((f, k) => f.classList.toggle('is-current', k === i));
      this.stepper.querySelectorAll('li').forEach((li, k) => {
        li.classList.toggle('is-current', k === i);
        li.classList.toggle('is-done', k < i);
        const dot = li.firstElementChild;
        if (k === i) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
        dot.disabled = k > i;
      });
      this.root.classList.toggle('is-first', i === 0);
      this.root.classList.toggle('is-last', i === this.steps.length - 1);

      if (!scroll) return;

      /* Focus the fieldset so a screen reader announces its legend, and only
         scroll if it is not already on screen: on a desktop the column usually
         is, and a page that lurches on every Next reads as broken. Under 62rem
         the stage is pinned at the top, so the target sits just below it. */
      const field = this.steps[i];
      field.focus({ preventScroll: true });
      const r = field.getBoundingClientRect();
      const pinned = this.stepMq.matches ? this.root.querySelector('.config__preview') : null;
      const ceiling = (pinned ? pinned.offsetHeight : 0) + 8;
      if (r.top >= ceiling && r.bottom <= window.innerHeight) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: r.top + window.scrollY - ceiling, behavior: reduce ? 'auto' : 'smooth' });
    }

    /* Arriving from the homepage teaser with a selection already made. Anything
       unrecognised is ignored rather than corrected: a stale link should land on
       the defaults, not on an error. */
    prefill() {
      const q = new URLSearchParams(window.location.search);
      if (!q.toString()) return;

      const pick = (key, attr) => {
        const v = q.get(key);
        if (!v) return;
        const el = this.root.querySelector(`[${attr}][value="${CSS.escape(v)}"]`);
        if (el) el.checked = true;
      };
      pick('glaze', 'data-glaze');
      pick('pattern', 'data-pattern');
      pick('mark', 'data-mark');
      pick('size', 'data-size');

      const text = (key, el) => {
        const v = q.get(key);
        if (v && el) el.value = v.slice(0, el.maxLength > 0 ? el.maxLength : undefined);
      };
      text('name', this.name);
      text('years', this.years);
    }

    checked(attr) {
      return this.root.querySelector(`[${attr}]:checked`);
    }

    paint() {
      const size = this.checked('data-size');
      const mark = this.checked('data-mark');
      const glaze = this.checked('data-glaze');
      const pattern = this.checked('data-pattern');
      if (!size || !this.urn) return;

      const d = size.dataset;
      this.urn.style.setProperty('--k', d.scale);
      this.urn.style.setProperty('--tk', d.tk);

      /* The drawing is tinted while there are no renders, and stays tinted for
         any combination that has no file yet — so a partial upload degrades one
         chip at a time instead of all at once. */
      if (glaze && glaze.dataset.hex) {
        this.urn.style.setProperty('--glaze', glaze.dataset.hex);
      }

      const key = `${glaze ? glaze.value : ''}|${pattern ? pattern.value : ''}`;
      let shown = null;
      this.root.querySelectorAll('[data-combo]').forEach((img) => {
        const on = img.dataset.combo === key;
        img.hidden = !on;
        if (on) shown = img;
      });
      this.urn.classList.toggle('urn--photo', Boolean(shown));

      this.selection = {
        glaze: glaze ? glaze.value : '',
        pattern: pattern ? pattern.value : '',
        mark: mark ? mark.value : '',
        size: size.dataset.label || '',
      };
      this.writeTags();
      this.writeHandoff();

      /* Guarded: in the teaser these spans are seeded by Liquid and there is no
         input to read. Painting them unconditionally would wipe the placeholder
         to an empty string on first repaint. */
      if (this.name) this.set('[data-urn-name]', this.value(this.name));
      if (this.years) this.set('[data-urn-years]', this.value(this.years));
      this.set('[data-urn-mark]', mark ? mark.value : '');
      /* `data-price-out`, not `data-price`. The size radios carry the value in a
         `data-price` attribute and they are earlier in the DOM, so a querySelector
         for `[data-price]` found an <input> and wrote the price into its
         textContent, where an input shows nothing. The spec line kept its em dash
         and nobody saw it while main-product still printed $139 above; cutting
         product.urn.json down to this section left it as the only price on the
         page. main-product has the same pair the other way round — its output
         <b data-price> is above its variant radios, so its querySelector happens
         to land right. That is luck, not design. */
      this.set('[data-price-out]', d.price);
      this.set('[data-price-label]', d.label);
      this.set('[data-preview-label]', d.label);

      const facts = this.root.querySelector('[data-preview-facts]');
      if (facts) {
        facts.textContent = '';
        [[d.fits, d.weight].filter(Boolean).join(' — '), [d.capacity, d.dimensions].filter(Boolean).join(' · ')]
          .filter(Boolean)
          .forEach((line) => {
            const p = document.createElement('p');
            p.textContent = line;
            facts.appendChild(p);
          });
      }
    }

    /* One hidden field, comma separated, because a customer form keeps tags and
       drops everything else. Prefixed by axis so the admin's customer list can be
       filtered by glaze or by size rather than searched through bare words.

       The engraving goes in too. `pet-toby` is an ugly way to store a name and it
       is the only way that survives: a tag is the last field standing. Commas are
       stripped rather than escaped — Shopify splits this value on them, so a comma
       in a name would silently become two tags.

       TWO SHAPES, BECAUSE TAGS MERGE. Submitting twice from one address does not
       make a second record; Shopify finds the customer by email and unions the
       tags in. Someone who lost two animals, or who changed their mind, then
       leaves `glaze-sage, glaze-clay, pet-Toby, pet-Luna` behind with nothing
       saying which went with which — data that looks present and is not usable.

       So the axis tags stay for filtering and counting, where merging is harmless,
       and one more tag carries the whole submission in a fixed order. That one is
       self-contained: two submissions leave two of them, each still readable on
       its own. It is the copy to trust when replying. */
    writeTags() {
      const field = this.root.querySelector('[data-tags]');
      if (!field) return;
      /* Commas split tags and the pipe divides the snapshot, so neither can
         survive inside a value someone typed. */
      const clean = (v) => (v || '').trim().replace(/[,|]/g, ' ').replace(/\s+/g, ' ');
      const verdict = this.checked('data-verdict');
      const s = this.selection;
      const name = clean(this.name && this.name.value);
      const years = clean(this.years && this.years.value);

      const axes = [
        'want-urn',
        s.glaze && `glaze-${s.glaze}`,
        s.pattern && `pattern-${s.pattern}`,
        s.size && `size-${s.size.toLowerCase()}`,
        verdict && `price-${verdict.value}`,
        name && `pet-${name}`,
        years && `years-${years}`,
      ].filter(Boolean);

      /* Fixed positions, empties kept, so it parses on a split even when a field
         was left alone. */
      const snapshot = ['urn', s.glaze, s.pattern, s.size.toLowerCase(), name, years,
                        verdict ? verdict.value : ''].join('|');

      field.value = axes.concat(snapshot).join(',');
    }

    /* Teaser only. Carries glaze and pattern so the product page opens on the
       piece that was just being looked at rather than on the defaults.

       The base URL must end in `#personalize` or this lands at the top of the
       product page, where the selection is invisible and the reflex is to start
       over — which is the bug this whole split exists to remove. The name and
       years lines below are inert while the teaser has no inputs; they stay so
       the href is still correct if one ever gets them back. */
    writeHandoff() {
      const link = this.root.querySelector('[data-handoff]');
      if (!link) return;
      const base = link.dataset.base || '#';
      if (base === '#') return;

      const q = new URLSearchParams();
      Object.entries(this.selection).forEach(([k, v]) => v && q.set(k, v));
      if (this.name && this.name.value.trim()) q.set('name', this.name.value.trim());
      if (this.years && this.years.value.trim()) q.set('years', this.years.value.trim());

      const [path, hash] = base.split('#');
      link.href = `${path}${path.includes('?') ? '&' : '?'}${q}${hash ? `#${hash}` : ''}`;
    }

    value(input) {
      if (!input) return '';
      return input.value.trim() || input.placeholder;
    }

    set(selector, text) {
      const el = this.root.querySelector(selector);
      if (el) el.textContent = text;
    }
  }

  document.querySelectorAll('[data-configurator]').forEach((el) => new UrnConfigurator(el));

  } catch(e) { console.error(e); }
})();
})();
